export default __webpack_public_path__ + "static/media/RateMyService-logo-new.dad2de7c.svg";